import React from "react";
import { useTranslation } from "react-i18next";
import { IconArrowUpRight } from "@tabler/icons-react";
import { useDismissible, DISMISS_KEYS } from "@/hooks/useDismissible";
import styles from "./LabInsightsBanner.module.css";

interface LabInsightsBannerProps {
  /** Invoked when the banner is tapped, before it is dismissed. */
  onClick?: () => void;
  className?: string;
}

/**
 * Slim gradient promo banner for the Lab Insights feature. Renders nothing once
 * tapped — the dismissal is persisted, so it never returns.
 */
const LabInsightsBanner: React.FC<LabInsightsBannerProps> = ({
  onClick,
  className = "",
}) => {
  const { t } = useTranslation();
  const { dismissed, dismiss } = useDismissible(DISMISS_KEYS.labInsightsBanner);

  if (dismissed) return null;

  return (
    <button
      type="button"
      className={`${styles.banner} ${className}`}
      onClick={() => {
        onClick?.();
        dismiss();
      }}
    >
      <span className={styles.bannerLeft}>
        <span className={styles.bannerNew}>{t("common.new")}</span>
        <span className={styles.bannerText}>{t("labInsights.bannerTitle")}</span>
      </span>
      <span className={styles.bannerArrow}>
        <IconArrowUpRight size={15} stroke={2} />
      </span>
    </button>
  );
};

export default LabInsightsBanner;
